<template>
    <CardPage :section="20" :page="5" nextLabel="Finish" :nextFunction="finish" :audio="true">
        <p>
            Amazing job! You’ve earned your last sticker for completing this action plan.
        </p>
        <ResponsiveImage :src="sticker.image" :alt="sticker.text"></ResponsiveImage>
    </CardPage>
</template>

<script>
import { get } from 'vuex-pathify';

export default {
    computed: {
        sticker: get('section20/sticker')
    },
    methods: {
        finish() {
            this.$store.set('section20/sticker@earned', true);
        }
    }
};
</script>
